<template>
	<div class="mine">
		<div class="page-content">
			<div class="top">
				<div class="setting">
					<!-- 客服图标移到右侧 -->
					<div class="service-icon" @click="toService">
						<van-icon name="chat-o" size="1.8rem" color="#fff" />
					</div>
				</div>
				<div class="avatar">
					<van-image round width="4.2rem" height="4.2rem" :src="userInfo.header_img" @click="doLogin()">
						<template v-slot:loading>
							<van-loading type="spinner"/>
						</template>
					</van-image>
					<div class="me">
						<div class="user" style="flex-direction: initial; align-items: center;">
							<p style="padding-bottom: 0px;">{{userInfo.username}}</p>
							<span style="margin-left: 10px;" v-if="userInfo.is_vip==1">
								<img :src="'img/vip'+userInfo.vip_level+'.png'" alt="" style="width: 90px;">
							</span>
						</div>
						<div class="ps">
							<span style="padding-left: 0px; margin: 4px 0px 2px;">{{$t('mine.xyfs')}}:{{userInfo.xyjf}}</span>
						</div>
						<div class="ps">
							<!-- 累计积分动态进度条 -->
							<div class="progress-container">
								<div class="progress-bar" :style="{ width: progressWidth + '%' }"></div>
							</div>
							<span>{{$t('mine.ljjf')}}: {{currentPoints}} / {{targetPoints}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="center">
				<div class="integral">
					<div @click="doPay()">
						<i class="van-badge__wrapper van-icon" style="color: rgb(0, 0, 0); font-size: 26px;">
							<img class="van-icon__image" src="/img/qianbao.png">
						</i>
						<span>{{$t('mine.recharge')}}</span>
					</div>
					<div @click="doWithdrawal()">
						<i class="van-badge__wrapper van-icon" style="color: rgb(0, 0, 0); font-size: 26px;">
							<img class="van-icon__image" src="/img/piao.png">
						</i>
						<span>{{$t('mine.withdraw')}}</span>
					</div>
				</div>
				<div class="mineJf animate__animated animate__flipInX">
					<div class="title">
						<p>{{$t('mine.money')}}</p>
					</div>
					<div class="reload">
						<h1>{{userInfo.money}}</h1>
						<div @click="onRefresh()">
							<span>(KRW)</span>
							<van-icon name="/img/reload.png" size="1.2rem" color="#fff" />
						</div>
					</div>
				</div>
				<div class="list animate__animated animate__fadeIn">
<!-- 					<div @click="showSetting()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/zhangdan.png"></i><span>{{$t('mine.infomation')}}</span></div> -->
					<div @click="$router.push({path:'/MoneyLog'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/shujuku.png"></i><span>{{$t('mine.moneylog')}}</span></div>
					<div @click="$router.push({path:'//Home'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/zhangdan2.png"></i><span>{{$t('mine.withdrawrecord')}}</span></div>
					<div @click="$router.push({path:'//Home'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/youxi.png"></i><span>{{$t('mine.gamerecord')}}</span></div>
					<div @click="toNotice()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/diwu.png"></i><span>{{$t('mine.notice')}}</span></div>
					<div @click="$router.push({path:'/Mymove'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/dianying.png"></i><span>{{$t('mine.mymove')}}</span></div>
<!--					<div @click="toLoginPassword()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/suo.png"></i><span>{{$t('mine.loginpwd')}}</span></div> -->
<!-- 					<div @click="toPayPassword()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/anquan.png"></i><span>{{$t('mine.paypwd')}}</span></div> -->  
					<div><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="img/bank.5cb207d4.png"></i><span>{{$t('common.setbank')}}</span></div>  
				</div>
<!--				<a class="btns" @click="loginout()">{{$t('mine.loginout')}}</a>  --> 
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      menu_top: 40,
      isLoading: false,
      // 累计积分相关数据
      currentPoints: 0,
      targetPoints: 1000,
      progressWidth: 0
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.$toast(this.$t('common.refresh'));
        } else {
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t('common.noallow'));
    },
    showSetting() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Infomation'})
      } else {
        this.$router.push({path:'/Login'})
      }
    },
    toPayPassword() {
      if(this.userInfo.paypassword !== this.$t('setting.payPasswordNotSet')){
        this.$toast(this.$t('mine.paypwdhasseted'));
      } else {
        this.$router.push({path:'/SetPayPassword'});
      }
    },
    toLoginPassword() {
      this.$router.push({path:'/SetLoginPassword'});
    },
    loginout() {
      localStorage.clear()
      this.$router.push({path:'/Login'});
    },
    toNotice() {
	 this.$router.push({path:'/Notice'})
      // if(localStorage.getItem('token')){
      //   this.$router.push({path:'/Notice'})
      // } else {
      //   this.$router.push({path:'/Login'})
      // }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.getUserInfo();
          this.$toast(this.$t('common.refresh'));
        } else {
          // this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    doLogin() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Infomation'});
      } else {
        this.$router.push({path:'/Login'})
      }
    },
    doPay() {
      this.$router.push("recharge");
      return false;
    },
    doWithdrawal() {
      // this.$http({
      //   method: 'get',
      //   url: 'user_get_bank'
      // }).then(res => {
      //   if(res.data.is_bank){
      //     // 使用完整路径，更清晰
      //     this.$router.push({path: '/ServiceOnline'});
      //   } else {
      //     this.$router.push({path: '/ServiceOnline'});
      //   //   this.$toast.fail(this.$t('mine.setbank'));
      //   }
      // })
	  this.$router.push({path: '/ServiceOnline'});
    },
    toService() {
      if(this.$store.getters.getBaseInfo.iskefu == 1){
        this.$router.push("ServiceOnline");
      } else {
        this.$toast.fail(this.$t('common.noallow'));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if(res.code === 200){
          this.userInfo = res.data;
          this.menu_top = 15;
          
          // 更新积分进度
          this.updatePointsProgress();
          
          if(this.userInfo.status !== 1){
            this.$toast(this.$t('accountOffline'));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    // 更新积分进度
    updatePointsProgress() {
      // 模拟积分数据，实际应从API获取
      this.currentPoints = this.userInfo.xyjf || 350;
      this.targetPoints = 1000;
      
      // 计算进度百分比
      this.progressWidth = Math.min((this.currentPoints / this.targetPoints) * 100, 100);
    }
  },
  created() {
    if(localStorage.getItem('token')){
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t('mine.lorr');
      this.userInfo.ip = this.$t('loginForMore');
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  },
  mounted() {
    // 初始化积分进度动画
    setTimeout(() => {
      this.updatePointsProgress();
    }, 300);
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/basenew.css";

:export {
  gbcolor: linear-gradient(30deg, #3498db, #8e44ad)
}

/* 主容器 */
.mine {
  width: 100%;
  min-height: 100vh;
  background: #f2f2f5;
  position: relative;
}

/* 页面内容区域 - 关键修复 */
.page-content {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  z-index: 1; /* 页面内容在底层 */
  padding-bottom: 60px; /* 为底部导航预留空间 */
  box-sizing: border-box;
}

.mine .van-share-sheet__description span {
  background: linear-gradient(30deg, #3498db, #8e44ad);
  padding: 10px 20px;
  font-size: 14px;
  display: inline-block;
  border-radius: 4px;
  color: #fff;
  margin: 4px 0;
}

.mine .top {
  width: 100%;
  height: 13.33333rem;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  position: relative;
  overflow: hidden;
  border-radius: 0 0 20px 20px;
}

.mine .top::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px;
  background: #f2f2f5;
  border-radius: 20px 20px 0 0;
}

.mine .top .setting {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 1rem;
  position: relative;
  z-index: 1;
}

.mine .top .setting .service-icon {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.mine .top .setting .service-icon:hover {
  transform: scale(1.1);
}

.mine .top .avatar {
  width: 100%;
  padding: 0 6%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 1.33333rem;
  position: relative;
  z-index: 1;
}

.mine .top .avatar .van-image {
  border: 4px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.mine .top .avatar .me {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 1.33333rem;
  flex: 1;
}

.mine .top .avatar .me .user {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}

.mine .top .avatar .me .user p {
  font-size: 1rem;
  color: #fff;
  padding-bottom: .33333rem;
  font-weight: 500;
  margin: 0;
}

.mine .top .avatar .me .user img {
  width: 4.66667rem;
  margin: 0 0;
}

.mine .top .avatar .me .ps {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 4px 0;
}

.mine .top .avatar .me .ps>span {
  padding-left: .33333rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: .73333rem;
}

/* 累计积分进度条样式 */
.mine .top .avatar .me .progress-container {
  width: 40%;
  height: 6px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  overflow: hidden;
  margin: 8px 0;
  position: relative;
}

.mine .top .avatar .me .progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #ffd700, #ffec8b);
  border-radius: 3px;
  transition: width 1s ease-in-out;
  position: relative;
  overflow: hidden;
}

.mine .top .avatar .me .progress-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.mine .center {
  width: 94%;
  margin: -3rem auto 0;
  position: relative;
  z-index: 2;
}

.mine .center .integral {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
}

.mine .center .integral:before {
  content: "";
  position: absolute;
  width: 1px;
  height: 1.33333rem;
  border-radius: .66667rem;
  background: #f2f2f5;
}

.mine .center .integral>div {
  width: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  padding: 0.5rem;
}

.mine .center .integral>div:hover {
  transform: translateY(-2px);
}

.mine .center .integral>div span {
  margin-left: .66667rem;
  color: #432989;
  font-weight: 600;
}

.mine .center .mineJf {
  width: 100%;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 1.2rem 0;
  margin-top: 1rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.mine .center .mineJf .title {
  display: flex;
  padding: 0 0 .66667rem;
  width: 90%;
  margin: 0 auto;
  justify-content: flex-start;
  align-items: center;
}

.mine .center .mineJf .title p {
  color: #fff;
  font-size: .93333rem;
  font-weight: 600;
  margin: 0;
}

.mine .center .mineJf .reload {
  width: 90%;
  margin: 0 auto;
  display: flex;
  padding-top: .33333rem;
  justify-content: space-between;
  align-items: center;
}

.mine .center .mineJf .reload h1 {
  color: #fff;
  font-size: 1.6rem;
  margin: 0;
  font-weight: bold;
}

.mine .center .mineJf .reload>div {
  color: #fff;
  font-size: .86667rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.mine .center .mineJf .reload>div:hover {
  transform: scale(1.05);
}

.mine .center .mineJf .reload>div span {
  padding-right: .66667rem;
}

.mine .center .mineJf .reload>div i {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: .33333rem;
  transition: all 0.3s;
}

.mine .center .btns {
  display: block;
  width: 100%;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  color: #fff;
  padding: 1rem 0;
  border-radius: 12px;
  font-size: .93333rem;
  cursor: pointer;
  margin: 1.66667rem auto 1rem;
  text-align: center;
  border: none;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  font-weight: 600;
}

.mine .center .btns:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.mine .center .list {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 1.2rem 0;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 1rem;
}

.mine .center .list>div {
  width: 33.3333%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 8px;
}

.mine .center .list>div:hover {
  transform: translateY(-2px);
  background: rgba(102, 126, 234, 0.05);
}

.mine .center .list>div span {
  color: #432788;
  padding: .53333rem 0;
  font-size: 0.85rem;
  font-weight: 500;
}

.mine .center .list>div>i {
  margin-bottom: 0.5rem;
}

/* 适配全面屏 */
@media screen and (max-width: 750px) {
  .page-content {
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
  }
}
</style>